import { render, staticRenderFns } from "./CardTransactionsP.vue?vue&type=template&id=2d8a4dc0"
import script from "./CardTransactionsP.vue?vue&type=script&lang=js"
export * from "./CardTransactionsP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports